import React, { useState } from "react";
import CreateLocationCategory from "./CreateLocationCategory";
import { ModalComponent, ToastMessage } from "components";

function NewLocationCategoryModal({
    showLocationCategoriesModal,
    handleCloseLocationCategoriesModal,
    setShowLocationCategoriesModal,
    setIsLocationCategoriesChange,
}) {
    const [showSuccessMessage, setShowSuccessMessage] = useState(false);
    const [locationName, setLocationName] = useState(null);
    // eslint-disable-next-line no-shadow
    const onSuccess = (locationName) => {
        setShowLocationCategoriesModal(false);
        setLocationName(locationName);
        setShowSuccessMessage(true);
    };
    return (
        <>
            <ModalComponent
                header="Create New Location Category"
                open={showLocationCategoriesModal}
                size="large"
                borderedHeader
                onClose={handleCloseLocationCategoriesModal}
            >
                <CreateLocationCategory
                    onClose={handleCloseLocationCategoriesModal}
                    setIsLocationCategoriesChange={setIsLocationCategoriesChange}
                    onSuccess={onSuccess}
                />
            </ModalComponent>
            {showSuccessMessage && (
                <ToastMessage
                    type="success"
                    showToast={showSuccessMessage}
                    setShowToast={setShowSuccessMessage}
                    name={locationName}
                    text="has been created successfully and is pending
                    verification."
                />
            )}
        </>
    );
}

export default NewLocationCategoryModal;
